// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"xYavQG2-as3E3MG0385XMQ==","tabsWrapper":"i9uujjGcmMKSMzPmTPhl4Q==","contentContainer":"AcOiS6YUWLgymzXf20vj8Q==","tabs":"PUGvWFPhUcE-ol4mG9LCsQ=="};